export const getActivityStatusLifeCycleKey = {
	all: ['statusLifeCycle'],
	activity_param: params => [
		...getActivityStatusLifeCycleKey.all,
		{ ...params },
	],
}
